<template>
  <v-dialog 
  transition="dialog-bottom-transition"
  v-model="show">
    <v-toolbar dark class="edit-item-header">
        <v-tabs style="margin-bottom:20px;">
          <v-tab
            key="truck_details"
            @click="ViewTruckDetails()"
          >
            Truck Details
          </v-tab>
          <!-- <v-tab
            v-if="truck !== undefined && truck.id !== undefined"
            key="client_trucks"
            @click="ViewTruckClients()"
          >
            Assigned Clients
          </v-tab> -->
          <v-tab
            v-if="truck !== undefined && truck.id !== undefined"
            key="truck_waybills"
            @click="ViewTruckWaybills()"
          >
            Trip History
          </v-tab>
        </v-tabs>
        <v-spacer></v-spacer>

        <!-- <v-btn icon dark @click="save">
        <v-icon color="primary">mdi-content-save-outline</v-icon>
        </v-btn> -->

        <v-btn icon dark @click="show = false">
        <v-icon color="primary">mdi-close</v-icon>
        </v-btn>

        <!-- <v-btn color="green" text @click="save" :loading="postLoading" :disabled="loading">
          <v-icon color="primary">{{ "mdi-content-save-outline" }}</v-icon>
        </v-btn> -->




    </v-toolbar>
    <v-card>
        <!-- <edit-item-fields v-if="view === 1"
            :entityName="entity_name" 
            :entity_fields="headers"
            :localizable_fields="localizable_fields"
            :truck="truck"
            @closeClicked="show = false;"
            @entityPosted="show = false;"
        >
        </edit-item-fields> -->

        <truck-details-tab v-if="view === 1"
            :entityName="entity_name" 
            :entity_fields="headers"
            :localizable_fields="localizable_fields"
            :truck="truck"
            @closeClicked="show = false;"
            @entityPosted="show = false;"
        >

        </truck-details-tab>
        

         <delivery-address-assignment v-if="view === 2 && truck !== undefined && truck.id !== undefined"
          :truck_id="truck.id"
          v-model="truck"
        >
        </delivery-address-assignment>

        <!-- <truck-history-tab v-if="view === 3 && truck !== undefined && truck.id !== undefined"
          :truck_id="truck.id"
          v-model="truck"
        >

        </truck-history-tab> -->

        <waybill-tracking v-if="view === 3 && truck !== undefined && truck.id !== undefined"
          :truck_id="truck.id"
          v-model="truck"
        >
        </waybill-tracking>
    </v-card>
  </v-dialog>
</template>
<script>
import EditItemFields from '../common/EditItemFields'
import TruckDetailsTab from '../truck/TruckDetailsTab'
import TruckHistoryTab from '../truck/TruckHistoryTab.vue'
import WaybillTracking from '../waybill/WaybillTracking'
import DeliveryAddressAssignment from './DeliveryAddressAssignment'
export default {
    components:{EditItemFields,WaybillTracking,DeliveryAddressAssignment,TruckDetailsTab,TruckHistoryTab},
    props:['headers','entity_name','title','truck','localizable_fields','isShown'],
    methods:{
        ViewTruckDetails(){
            this.view = 1
        },
        ViewTruckClients(){
            this.view = 2
        },
        ViewTruckWaybills(){
            this.view = 3
        }
    },
    data(){
        return {
            view:1,
        }
    },
    created(){
        this.entity_name = 'truck'
    },
    computed: {
        show: {
            get() {
                return this.isShown
            },
            set(value) {
                this.$emit('changed', value)
            }
        }
    },
    model: {
        prop: 'isShown',
        event: 'changed'
    },
    watch : {
      isShown: function(val) {
        if(val === true) {
          this.view = 1
        }
      }
    }
}
</script>